import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import Calendar from "@/views/Calendar.vue";
import Categories from "@/views/Categories.vue";
import Listings from "@/views/Listings.vue";
import Search from "@/views/Search.vue";
import Listing from "@/views/Listing.vue";
import Admin from "@/views/Admin.vue";
import ProviderLogin from "@/views/ProviderLogin.vue";
import ProviderRegister from "@/views/ProviderRegister.vue";
import ProviderForgotPassword from "@/views/ProviderForgotPassword.vue";
import ProviderResetPassword from "@/views/ProviderResetPassword.vue";
import AdminProviders from "@/views/admin/AdminProviders.vue";
import AdminPendingListings from "@/views/admin/AdminPendingListings.vue";
import AdminDashboard from "@/views/admin/AdminDashboard.vue";
import ProviderDashboard from "@/views/ProviderDashboard.vue";
import ProviderListings from "@/views/provider/ProviderListings.vue";
import ProviderListingForm from "@/views/provider/ProviderListingForm.vue";
import ChangePassword from "@/views/admin/ChangePassword.vue";
import AdminCategories from "@/views/admin/AdminCategories.vue";
import AdminListings from "@/views/admin/AdminListings.vue";
import AdminServices from "@/views/admin/AdminServices.vue";
import AdminSponsors from "@/views/admin/AdminSponsors.vue";
import AdminSearches from "@/views/admin/AdminSearches.vue";
import AdminDeadLinks from "@/views/admin/AdminDeadLinks.vue";
import AdminLinkClicks from "@/views/admin/AdminLinkClicks.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/about",
      name: "About",
      component: About
    },
    {
      path: "/calendar",
      name: "Calendar",
      component: Calendar
    },
    {
      path: "/categories",
      name: "Categories",
      component: Categories
    },
    {
      path: "/categories/:categoryId",
      name: "Listings",
      component: Listings
    },
    {
      path: "/search/:searchTerm",
      name: "Search",
      component: Search
    },
    {
      path: "/listing/:id",
      name: "listing",
      component: Listing
    },
    {
      path: "/provider-login",
      name: "Provider-Login",
      component: ProviderLogin
    },
    {
      path: "/provider-register",
      name: "Provider-Register",
      component: ProviderRegister
    },
    {
      path: "/provider-forgot-password",
      name: "Provider-Forgot-Password",
      component: ProviderForgotPassword
    },
    {
      path: "/provider-reset-password",
      name: "Provider-Reset-Password",
      component: ProviderResetPassword
    },
    {
      path: "/provider-dashboard",
      component: ProviderDashboard,
      meta: { requiresProvider: true },
      children: [
        { path: "/", name: "Provider-Dashboard", component: ProviderListings },
        {
          path: "new",
          name: "Provider-New-Listing",
          component: ProviderListingForm
        },
        {
          path: "edit/:id",
          name: "Provider-Edit-Listing",
          component: ProviderListingForm
        }
      ]
    },
    {
      path: "/admin",
      component: Admin,
      children: [
        {
          path: "/",
          name: "Admin-Dashboard",
          component: AdminDashboard
        },
        {
          path: "change-password",
          name: "Change-Password",
          component: ChangePassword
        },
        {
          path: "categories",
          name: "Admin-Categories",
          component: AdminCategories
        },
        {
          path: "listings",
          name: "Admin-Listings",
          component: AdminListings
        },
        {
          path: "services",
          name: "Admin-Services",
          component: AdminServices
        },
        {
          path: "sponsors",
          name: "Admin-Sponsors",
          component: AdminSponsors
        },
        {
          path: "searches",
          name: "Admin-Searches",
          component: AdminSearches
        },
        {
          path: "dead-links",
          name: "Admin-Dead-Links",
          component: AdminDeadLinks
        },
        {
          path: "link-clicks",
          name: "Admin-Link-Clicks",
          component: AdminLinkClicks
        },
        {
          path: "providers",
          name: "Admin-Providers",
          component: AdminProviders
        },
        {
          path: "pending-listings",
          name: "Admin-Pending-Listings",
          component: AdminPendingListings
        },
        {
          path: "*",
          redirect: "/admin"
        }
      ]
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requiresProvider)) {
    if (!store.state.providerToken) {
      return next({ name: "Provider-Login", query: { redirect: to.fullPath } });
    }
  }
  next();
});

export default router;
